var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',{staticClass:"banner"},[_c('DynamicLinker',{staticClass:"overflow-hidden",attrs:{"item":_vm.data}},[_c('img',{staticClass:"w-100 h-100",attrs:{"loading":"lazy","src":_vm.data.picture,"alt":""}})])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }